if (!customElements.get('p4-team-carousel')) customElements.define('p4-team-carousel', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.slides = [...this.querySelectorAll('[data-team-slide]')];
  this.index = 0;
  this.preference = matchMedia('(prefers-reduced-motion: reduce)');
  this.classList.add('is-ready');
  this.querySelector('.p4-home-team__controls').hidden = false;
  this.show = (index) => {
   this.index = (index + this.slides.length) % this.slides.length;
   this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
   this.querySelectorAll('[data-team-index]').forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
  };
  this.start = () => {
   clearInterval(this.timer);
   this.timer = setInterval(() => {
    const rect = this.getBoundingClientRect();
    if (!this.preference.matches && !document.hidden && rect.top < innerHeight && rect.bottom > 0) this.show(this.index + 1);
   }, 10000);
  };
  this.onClick = (event) => {
   const button = event.target.closest('button');
   if (!button) return;
   if (button.hasAttribute('data-team-prev')) this.show(this.index - 1);
   else if (button.hasAttribute('data-team-next')) this.show(this.index + 1);
   else if (button.hasAttribute('data-team-index')) this.show(Number(button.dataset.teamIndex));
   else return;
   this.start();
  };
  this.addEventListener('click', this.onClick);
  this.show(1);
  this.start();
 }
 disconnectedCallback() {
  clearInterval(this.timer);
  this.removeEventListener('click', this.onClick);
  this.ready = false;
 }
});
